export enum TipoAvaliacaoEnum {
	AVALIACAO_DESEMPENHO = 'avaliacao-desempenho',
	AVALIACAO_ESTAGIO_PROBATORIO = 'avaliacao-estagio-probatorio'
}
